var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Subject } from '@/models/Subject';
import { Template as TemplateModel } from '@/models/Template';
import ErrorHandler from '@/support/ErrorHandler';
import { sanitizeString } from '@/support/String';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import AQuillEditor from '@/components/AQuillEditor/AQuillEditor.vue';
let Template = class Template extends Vue {
    constructor() {
        super(...arguments);
        this.templateClone = null;
        this.fileName = '';
        this.newFile = null;
        this.isStoring = false;
        this.isUploading = false;
        this.isEditing = false;
        this.isDefault = false;
        this.isShowingDialog = false;
        this.selectedTemplate = null;
        this.fileInput = null;
    }
    get editorOptions() {
        return {
            placeholder: this.$t('template.placeholder'),
        };
    }
    get dialogOptions() {
        const template = this.templateClone;
        return {
            title: template.value || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('dialogOptions.item.step') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!template) {
                            return;
                        }
                        template
                            .subject(this.subject)
                            .delete()
                            .then(() => {
                            if (template.id !== undefined) {
                                this.$emit('templateRemoved', template);
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.templateClone = cloneDeep(this.template);
        this.isDefault = this.templateClone && this.templateClone.is_default ? true : false;
    }
    remove() {
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    async update() {
        if (!this.templateClone) {
            return;
        }
        const payload = {
            value: this.templateClone.value,
            is_default: this.isDefault ? '1' : '0',
        };
        if (!this.templateClone.file && !this.newFile) {
            payload.file = null;
        }
        if (this.newFile) {
            await this.postFile();
        }
        this.templateClone
            .subject(this.subject)
            .update(payload)
            .then((template) => {
            if (this.fileInput) {
                this.fileInput.removeAttribute('value');
                this.fileInput.setAttribute('value', '');
                this.templateClone = template;
            }
            if (this.templateClone) {
                this.$emit('templateUpdated', this.templateClone.id);
            }
            this.isEditing = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    inputChanged(event, template) {
        this.fileInput = event.target;
        const files = this.fileInput.files;
        if (files === null || !files.length) {
            return;
        }
        this.newFile = files[0];
        this.fileName = files[0].name;
    }
    async postFile() {
        if (!this.templateClone) {
            return;
        }
        await this.templateClone
            .subjectTemplate(this.subject)
            .create({
            file: this.newFile,
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    setDefault() {
        if (!this.isEditing) {
            return;
        }
        this.isDefault = !this.isDefault;
    }
    removeFileFromTemplate() {
        if (!this.templateClone) {
            return;
        }
        this.templateClone.file = null;
    }
    removeFileNewFile() {
        if (this.fileInput) {
            this.fileInput.removeAttribute('value');
            this.fileInput.setAttribute('value', '');
        }
        if (this.templateClone) {
            this.templateClone.file = null;
        }
        this.newFile = null;
    }
    openFileInput() {
        const input = document.getElementById('uploadFile');
        if (input) {
            input.click();
        }
    }
    createTemplateClone() {
        this.templateClone = cloneDeep(this.template);
    }
    resetTemplate() {
        this.templateClone = cloneDeep(this.template);
        this.isDefault = (this.templateClone && this.templateClone.is_default) || false;
        this.newFile = null;
        this.fileName = '';
    }
    sanitizeString(value) {
        return sanitizeString(value, true);
    }
};
__decorate([
    Prop({ default: new Subject() }),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], Template.prototype, "subject", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof TemplateModel !== "undefined" && TemplateModel) === "function" ? _b : Object)
], Template.prototype, "template", void 0);
Template = __decorate([
    Component({
        components: {
            AQuillEditor,
        },
    })
], Template);
export default Template;
